import {
	dotnetLogo,
	reactLogo,
	remixLogo,
	websiteLogo,
} from '#app/routes/_marketing+/logos/logos.js'

export default function Developer() {
	return (
		<div className="mb-1 grow">
			<div className="container mx-auto flex justify-center pt-16">
				<div>
					<h1 className="mx-auto w-5/6 pb-6 text-center text-3xl font-extrabold text-gray-800 sm:w-4/6 xl:text-4xl">
						Developer
					</h1>
					<p className="pb-3 text-center text-lg font-normal text-gray-500">
						I'm a software engineer and developer advocate. I love building new
						tools and sharing what I learn with others. I've been working in the
						tech industry for over 25 years and have experience in a wide range
						of technologies.
					</p>
				</div>
			</div>
			<div className="w-full bg-gray-100 px-10 py-10">
				<div className="container mx-auto">
					<div
						role="list"
						aria-label="Developer tools"
						className="flex-wrap items-center sm:flex sm:justify-around md:flex md:justify-around lg:flex lg:justify-around xl:justify-between"
					>
						<div
							role="listitem"
							className="relative mb-32 mt-16 sm:mb-24 sm:w-3/4 md:w-2/5 lg:w-2/5 xl:w-1/3 xl:max-w-sm"
						>
							<div className="flex h-72 flex-col overflow-hidden rounded bg-white shadow-md">
								<div className="absolute -mt-20 flex w-full justify-center">
									<div className="h-32 w-32">
										<img
											src={reactLogo}
											alt="React"
											role="img"
											className="h-full w-full rounded-full object-cover shadow-md"
										/>
									</div>
								</div>
								<div className="mt-16 flex-grow px-6">
									<h1 className="mb-1 text-center text-3xl font-bold">React</h1>
									<p className="text-center text-sm text-gray-800">
										Front End Library
									</p>
									<p className="pt-3 text-center text-base font-normal text-gray-600">
										React is a JavaScript library for building user interfaces.
									</p>
								</div>
								<div className="flex w-full justify-center pb-5 pt-5">
									<a href="https://github.com/facebook/react" className="mx-5">
										<div aria-label="Github" role="img">
											<svg
												xmlns="http://www.w3.org/2000/svg"
												width="24"
												height="24"
												viewBox="0 0 24 24"
												fill="none"
												stroke="#718096"
												strokeWidth="1.5"
												strokeLinecap="round"
												strokeLinejoin="round"
												className="feather feather-github"
											>
												<path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path>
											</svg>
										</div>
									</a>
									<a href="https://twitter.com/reactjs" className="mx-5">
										<div aria-label="Twitter" role="img">
											<svg
												xmlns="http://www.w3.org/2000/svg"
												width="24"
												height="24"
												viewBox="0 0 24 24"
												fill="none"
												stroke="#718096"
												strokeWidth="1.5"
												strokeLinecap="round"
												strokeLinejoin="round"
												className="feather feather-twitter"
											>
												<path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path>
											</svg>
										</div>
									</a>
									<a href="https://react.dev" className="mx-5">
										<div aria-label="Website" role="img">
											<img src={websiteLogo} alt="Website link" />
										</div>
									</a>
								</div>
							</div>
						</div>

						<div
							role="listitem"
							className="relative mb-32 mt-16 sm:mb-24 sm:w-3/4 md:w-2/5 lg:w-2/5 xl:w-1/3 xl:max-w-sm"
						>
							<div className="flex h-72 flex-col overflow-hidden rounded bg-white shadow-md">
								<div className="absolute -mt-20 flex w-full justify-center">
									<div className="h-32 w-32">
										<img
											src={remixLogo}
											alt="Remix.run"
											role="img"
											className="h-full w-full rounded-full object-cover shadow-md"
										/>
									</div>
								</div>
								<div className="mt-16 flex-grow px-6">
									<h1 className="mb-1 text-center text-3xl font-bold">
										Remix.Run
									</h1>
									<p className="text-center text-sm text-gray-800">
										Full-stack web framework for React
									</p>
									<p className="pt-3 text-center text-base font-normal text-gray-600">
										Remix is a full-stack web framework for React. It's built
										for speed.
									</p>
								</div>
								<div className="flex w-full justify-center pb-5 pt-5">
									<a href="https://github.com/remix-run" className="mx-5">
										<div aria-label="Github" role="img">
											<svg
												xmlns="http://www.w3.org/2000/svg"
												width="24"
												height="24"
												viewBox="0 0 24 24"
												fill="none"
												stroke="#718096"
												strokeWidth="1.5"
												strokeLinecap="round"
												strokeLinejoin="round"
												className="feather feather-github"
											>
												<path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path>
											</svg>
										</div>
									</a>
									<a href="https://twitter.com/remix_run" className="mx-5">
										<div aria-label="Twitter" role="img">
											<svg
												xmlns="http://www.w3.org/2000/svg"
												width="24"
												height="24"
												viewBox="0 0 24 24"
												fill="none"
												stroke="#718096"
												strokeWidth="1.5"
												strokeLinecap="round"
												strokeLinejoin="round"
												className="feather feather-twitter"
											>
												<path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path>
											</svg>
										</div>
									</a>
									<a href="https://remix.run" className="mx-5">
										<div aria-label="Website" role="img">
											<img src={websiteLogo} alt="Website link" />
										</div>
									</a>
								</div>
							</div>
						</div>
						<div
							role="listitem"
							className="relative mb-32 mt-16 sm:mb-24 sm:w-3/4 md:w-2/5 lg:w-2/5 xl:w-1/3 xl:max-w-sm"
						>
							<div className="flex h-72 flex-col overflow-hidden rounded bg-white shadow-md">
								<div className="absolute -mt-20 flex w-full justify-center">
									<div className="h-32 w-32">
										<img
											src={dotnetLogo}
											alt="C# .NET"
											role="img"
											className="h-full w-full rounded-full object-cover shadow-md"
										/>
									</div>
								</div>
								<div className="mt-16 flex-grow px-6">
									<h1 className="mb-1 text-center text-3xl font-bold">
										C# .NET
									</h1>
									<p className="text-center text-sm text-gray-800">
										Modern, innovative, open-source language
									</p>
									<p className="pt-3 text-center text-base font-normal text-gray-600">
										C# is a modern, innovative, open-source, cross-platform
										object-oriented programming language.
									</p>
								</div>
								<div className="flex w-full justify-center pb-5 pt-5">
									<a
										href="https://github.com/dotnet?WT.mc_id=dotnet-35129-website"
										className="mx-5"
									>
										<div aria-label="Github" role="img">
											<svg
												xmlns="http://www.w3.org/2000/svg"
												width="24"
												height="24"
												viewBox="0 0 24 24"
												fill="none"
												stroke="#718096"
												strokeWidth="1.5"
												strokeLinecap="round"
												strokeLinejoin="round"
												className="feather feather-github"
											>
												<path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path>
											</svg>
										</div>
									</a>
									<a href="https://twitter.com/dotnet" className="mx-5">
										<div aria-label="Twitter" role="img">
											<svg
												xmlns="http://www.w3.org/2000/svg"
												width="24"
												height="24"
												viewBox="0 0 24 24"
												fill="none"
												stroke="#718096"
												strokeWidth="1.5"
												strokeLinecap="round"
												strokeLinejoin="round"
												className="feather feather-twitter"
											>
												<path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path>
											</svg>
										</div>
									</a>
									<a
										href="https://dotnet.microsoft.com/en-us/languages/csharp"
										className="mx-5"
									>
										<div aria-label="Website" role="img">
											<img src={websiteLogo} alt="Website link" />
										</div>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
